<script>
import { mapState } from 'vuex';
import Loading from "@/components/Loading";
import PageHeader from "@/components/page-header";
import {updateBankAccount, createBankAccount, getBankAccount} from "@/api/bankAccount";
import {getShortSites} from "@/api/sites";
import {getBanks} from "@/api/bank";
import Vue from "vue";

export default {
  components: {PageHeader, Loading},
  data() {
    return {
      loading: false,
      title: this.$route.params.bankId ? "Banka Hesabı Düzenle" : "Banka Hesabı Ekle",
      items: [
        {
          text: "Banka Hesapları",
          href: "/bank-accounts"
        },
        {
          text: this.$route.params.siteId ? "Banka Hesabı Düzenle" : "Banka Hesabı Ekle",
          active: true
        }
      ],
      selectedEnabledForSite: null,
      vip: {
        site: null,
        userId: null
      },
      form: {
        name: null,
        iban: null,
        bank: null,
        transactionLimit: null,
        minTransaction: null,
        maxTransaction: null,
        autoVipFeature: null,
        autoVipCount: null,
        type: "standard",
        customers: [],
        sites: [],
        enabledFor: "all",
        mappedVipCustomers: [],
        emailCredentials: {
          email: null,
          password: null
        },
        originalEmail: null,
        emailService: false,
      },
      sites: [],
      banks: [],
    };
  },
  computed: {
    ...mapState({
      config: state => state.auth.config,
      user: state => state.auth.user
    }),
  },
  methods: {
    findCustomer(site, userId) {
      return this.form.customers.includes(`${site}_${userId}`);
    },
    findSite(site) {
      return this.form.sites.includes(site);
    },
    getSiteName(site) {
      const find = this.sites.filter(f => f._id === site);
      if (find.length > 0) {
        return find[0].name;
      }
      return null;
    },
    addVipCustomer() {
      if (this.vip.site !== null || this.vip.userId !== null) {
        const checkExists = this.findCustomer(this.vip.site, this.vip.userId);
        if (!checkExists) {
          this.form.mappedVipCustomers.push({
            site: this.vip.site,
            userId: this.vip.userId.trim()
          });
          this.form.customers.push(`${this.vip.site}_${this.vip.userId.trim()}`);
        }
      }
    },
    addEnabledForSite() {
      if (this.selectedEnabledForSite !== null) {
        const checkExists = this.findSite(this.selectedEnabledForSite);
        if (!checkExists) {
          this.form.sites.push(this.selectedEnabledForSite);
        }
      }
    },
    removeEnabledForSite(site) {
      const index = this.form.sites.indexOf(site);
      if (index > -1) {
        this.form.sites.splice(index, 1);
      }
    },
    removeVipCustomer(site, userId) {
      const index = this.form.customers.indexOf(`${site}_${userId}`);
      if (index > -1) {
        this.form.customers.splice(index, 1);
      }

      for (let i = this.form.mappedVipCustomers.length - 1; i >= 0; --i) {
        if (this.form.mappedVipCustomers[i].userId === userId && this.form.mappedVipCustomers[i].site === site) {
          this.form.mappedVipCustomers.splice(i,1);
        }
      }
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          const data = {
            name: this.form.name,
            iban: this.form.iban,
            bank: this.form.bank,
            enabledFor: this.form.enabledFor,
            transactionLimit: this.form.transactionLimit,
            minTransaction: this.form.minTransaction,
            maxTransaction: this.form.maxTransaction,
            type: this.form.type,
            sites: this.form.sites,
            emailService: this.form.emailService,
            emailCredentials: this.form.emailCredentials,
            originalEmail: this.form.originalEmail,
            autoVipFeature: this.form.autoVipFeature,
            autoVipCount: this.form.autoVipCount,
            customers: this.form.customers
          };

          if (this.$route.params.bankAccountId) {
            updateBankAccount(this.$route.params.bankAccountId, data).then(() => {
              this.$router.push('/bank-accounts');
            }).finally(() => {
              this.loading = false;
            })
          } else {
            createBankAccount(data).then(() => {
              this.$router.push('/bank-accounts');
            }).finally(() => {
              this.loading = false;
            })
          }
        }
      });
    }
  },
  mounted() {
    getShortSites({page: 1, limit: 1000}).then((response) => {
      this.sites = response.data.data.docs;

      getBanks({page: 1, limit: 1000}).then((response) => {
        this.banks = response.data.data.docs;
        if (this.user.role === "iban_control") {
          this.banks = this.banks.filter(b => b.type === 'paparatobank')
        }
        if (this.$route.params.bankAccountId) {
          getBankAccount(this.$route.params.bankAccountId).then((response) => {
            const mappedVipCustomers = response.data.data.customers ? response.data.data.customers.map((c) => {
              const data = c.split("_");
              return {
                site: data[0],
                userId: data[1],
              };
            }) : [];
            Vue.set(this, 'form', response.data.data)
            if (!this.form.emailCredentials) {
              this.form.emailCredentials = {
                email: null,
                password: null
              };
            }
            Vue.set(this.form, 'mappedVipCustomers', mappedVipCustomers)
            this.loading = false;
          })
        } else {
          this.loading = false;
        }
      });
    });
  }
};

</script>
<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <Loading v-if="loading"/>
          <div class="card-body">
            <form @submit.prevent="submitForm">
            <div class="row">
                <div class="col-6">
                  <div class="form-group mb-2">
                    <label for="name" class="col-form-label">Hesap Adı</label>
                    <input v-validate="'required'" id="name" name="name" v-model="form.name" type="text" class="form-control"/>
                    <template v-if="errors.firstByRule('name', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group mb-2">
                    <label for="bank" class="col-form-label">Banka</label>
                    <select v-validate="'required'" name="type" id="bank" class="form-control custom-select" v-model="form.bank">
                      <option v-for="bank in banks" :key="bank._id" :value="bank._id">{{bank.name}}</option>
                    </select>
                    <template v-if="errors.firstByRule('bank', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="iban" class="col-form-label">IBAN</label>
                    <input v-validate="'required'" id="iban" name="iban" v-model="form.iban" type="text" class="form-control"/>
                    <template v-if="errors.firstByRule('iban', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="type" class="col-form-label">Hesap Tipi</label>
                    <select v-validate="'required'" name="type" id="type" class="form-control custom-select" v-model="form.type">
                      <option value="standard">Standard</option>
                      <option value="vip">VIP</option>
                    </select>
                    <template v-if="errors.firstByRule('type', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="type" class="col-form-label">Gösterim tipi</label>
                    <select v-validate="'required'" name="enabledFor" id="enabledFor" class="form-control custom-select" v-model="form.enabledFor">
                      <option value="all">Tüm sitelere göster</option>
                      <option value="never">Hiç bir siteye gösterme</option>
                      <option value="sites">Özel sitelere göster</option>
                    </select>
                    <template v-if="errors.firstByRule('enabledFor', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>


                <div v-if="config.emailService" class="col-12">
                  <hr>
                  <div class="row">
                    <div class="col-4">
                      <div class="form-group mb-2">
                        <label for="emailService" class="col-form-label">E-Mail Servisi</label>
                        <select id="emailService" class="form-control custom-select" v-model="form.emailService">
                          <option :value="true">Açık</option>
                          <option :value="false">Kapalı</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="form-group mb-2">
                        <label for="emailAddress" class="col-form-label">E-Posta Adresi</label>
                        <input id="emailAddress" :readonly="!form.emailService" name="email" v-model="form.emailCredentials.email" type="email" placeholder="@yandex.com" class="form-control"/>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="form-group mb-2">
                        <label for="emailPassword" class="col-form-label">E-Posta Şifresi</label>
                        <input id="emailPassword" :readonly="!form.emailService" name="email" v-model="form.emailCredentials.password" type="text" placeholder="*****" class="form-control"/>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group mb-2">
                        <label for="originalEmail" class="col-form-label">Varsayılan E-Posta Adresi (Hesabın orjinal email adresi)</label>
                        <input id="originalEmail" name="email" v-model="form.originalEmail" type="email" class="form-control"/>
                      </div>
                    </div>
                    <div class="col-12">
                      <code>
                        Yandex Mail Ayarları üzerinden IMAP izni verilmelidir. Ayrıca IMAP ayarları kısmından Portal şifresi ile giriş yetkisi tanımlanmalıdır.
                      </code>
                    </div>
                  </div>
                  <hr>
                </div>

                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="transactionLimit" class="col-form-label">Günlük İşlem Limiti</label>
                    <input id="transactionLimit" name="transactionLimit" v-model="form.transactionLimit" type="number" class="form-control"/>
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="minTransaction" class="col-form-label">Minimum İşlem Tutarı</label>
                    <input id="minTransaction" name="minTransaction" v-model="form.minTransaction" type="number" class="form-control"/>
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="maxTransaction" class="col-form-label">Maximum İşlem Tutarı</label>
                    <input id="maxTransaction" name="maxTransaction" v-model="form.maxTransaction" type="number" class="form-control"/>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="form-group mb-2">
                    <label for="autoVipFeature" class="col-form-label">Otomatik VIP</label>
                    <select v-validate="'required'" name="type" id="autoVipFeature" class="form-control custom-select" v-model="form.autoVipFeature">
                      <option :value="true">Açık</option>
                      <option :value="false">Kapalı</option>
                    </select>
                    <template v-if="errors.firstByRule('autoVipFeature', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>
                <div v-if="form.autoVipFeature" class="col-6">
                  <div class="form-group mb-2">
                    <label for="autoVipCount" class="col-form-label">Otomatik VIP Kullanıcı Sınırı</label>
                    <input id="autoVipCount" name="autoVipCount" v-model="form.autoVipCount" type="number" class="form-control"/>
                    <template v-if="errors.firstByRule('autoVipCount', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>
              </div>



              <div class="mt-3" v-if="form.type === 'vip'">
                <h5>VIP Ayarları</h5>
                <div class="d-flex align-items-center justify-content-between">
                  <div style="width:100%;" class="mr-2">
                    <div class="form-group mb-2">
                      <label class="col-form-label">Site</label>
                      <select class="form-control custom-select" v-model="vip.site">
                        <option v-for="site in sites" :key="site._id" :value="site._id">{{site.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div style="width:100%;" class="mr-2">
                    <div class="form-group mb-2">
                      <label class="col-form-label">Kullanıcı ID</label>
                      <input v-model="vip.userId" type="text" class="form-control"/>
                    </div>
                  </div>
                  <div style="width:250px; padding-top:30px;">
                    <button type="button" @click="addVipCustomer" class="btn btn-success btn-sm">Vip Müşteri Ekle</button>
                  </div>
                </div>
                <table class="table table-centered table-nowrap table-hover">
                  <thead>
                  <tr>
                    <th>Site</th>
                    <th>Kullanıcı ID</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(customer, i) in form.mappedVipCustomers" :key="i">
                    <td><h5 class="font-size-14 mb-0">{{getSiteName(customer.site)}}</h5></td>
                    <td>{{customer.userId}}</td>
                    <td class="text-right">
                      <a class="btn btn-danger btn-sm" @click="removeVipCustomer(customer.site, customer.userId)">Kaldır</a>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-3" v-if="form.enabledFor === 'sites'">
                <h5>Gösterim tipi site seçimi</h5>
                <div class="d-flex align-items-center justify-content-between">
                  <div style="width:100%;" class="mr-2">
                    <div class="form-group mb-2">
                      <label class="col-form-label">Site</label>
                      <select class="form-control custom-select" v-model="selectedEnabledForSite">
                        <option v-for="site in sites" :key="site._id" :value="site._id">{{site.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div style="width:250px; padding-top:30px;">
                    <a href="#" @click="addEnabledForSite" class="btn btn-success btn-sm">Site Ekle</a>
                  </div>
                </div>
                <table class="table table-centered table-nowrap table-hover">
                  <thead>
                  <tr>
                    <th>Site</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(site, i) in form.sites" :key="i">
                    <td><h5 class="font-size-14 mb-0">{{getSiteName(site)}}</h5></td>
                    <td class="text-right">
                      <a class="btn btn-danger btn-sm" @click="removeEnabledForSite(site)">Kaldır</a>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="d-flex justify-content-end">
                <button type="submit" class="btn btn-primary">{{$route.params.bankAccountId ? 'Banka Hesabı Düzenle' : 'Banka Hesabı Ekle'}}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
